import { Typography, Box } from '@mui/material';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import OpenWithRoundedIcon from '@mui/icons-material/OpenWithRounded';

const DocsPreferences = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Configuration
      </Typography>

      <Typography variant="body1" paragraph>
        The configuration section allows you to specify the dimensions and
        template for the timetable. You can specify the number of days, teaching
        hours and the lunch breaks in between the classes.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Setting Up Configuration
      </Typography>
      <Typography variant="body1" paragraph>
        To configure the timetable, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Preferences</strong> section in the
            dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Define working days (e.g., Monday, Tuesday, Wednesday, and so on)
            along the columns of the configuration table.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Set the number of periods per day and the duration of each period
            (e.g., 09:00 - 09:50, 10:00 - 10:50, 11:00 - 11:50, and so on) along
            the rows of the configuration table.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Specify break times{' '}
            <DisabledByDefaultOutlinedIcon
              fontSize="small"
              sx={{ verticalAlign: 'middle', mx: 0.5 }}
            />{' '}
            and other special scheduling rules.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            You can use the floating configuration{' '}
            <OpenWithRoundedIcon
              fontSize="small"
              sx={{ verticalAlign: 'middle', mx: 0.5 }}
            />{' '}
            button to add/remove days and time slots.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click <strong>Save</strong> to apply the configuration settings.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsPreferences;
